import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { View, Spinner } from '@smarterservices/smarter-ui';

// Lazy load pages for better performance
const Login = lazy(() => import('../pages/Login'));
const Register = lazy(() => import('../pages/Register'));
const ExamList = lazy(() => import('../pages/ExamList'));
const ExamSchedule = lazy(() => import('../pages/ExamSchedule'));
const Payment = lazy(() => import('../pages/Payment'));
const Appointments = lazy(() => import('../pages/Appointments'));
const PublicLayout = lazy(() => import('../pages/PublicLayout'));

const PublicRoutes = () => {
  return (
    <Suspense
      fallback={
        <View as="div" display="flex" justifyContent="center" alignItems="center" height="100vh">
          <Spinner size="large" />
        </View>
      }
    >
      <Routes>
        <Route path="/" element={<Navigate to="/public/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Protected routes */}
        <Route path="/" element={<PublicLayout />}>
          <Route path="exams" element={<ExamList />} />
          <Route path="exams/:examId/schedule" element={<ExamSchedule />} />
          <Route path="exams/:examId/payment" element={<Payment />} />
          <Route path="appointments" element={<Appointments />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default PublicRoutes;
